import { render, staticRenderFns } from "./ItemRow.vue?vue&type=template&id=fb5750e6&"
import script from "./ItemRow.vue?vue&type=script&lang=ts&"
export * from "./ItemRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports